export const getBoolByLsnCode = (code) => ({
  isLever1: code === 'lever1',
  isLever5: code === 'lever5',
  isLever6: code === 'lever6',
  isLever7: code === 'lever7',
})